(() => {

  async function initLooseTeaVariants() {

    const marker =
      document.querySelector('.t-loose-tea-product');

    if (!marker) return;


    const scope =
      marker.closest('.product__info-container') ||
      marker.closest('section') ||
      document;


    /* =========================================
       PRODUCT INTRO CLASSES
    ========================================= */

    const productInfo =
      document.querySelector('.product__info-container');

    if (productInfo) {

      const textBlocks =
        productInfo.querySelectorAll('.product__text');

      if (textBlocks[0]) {
        textBlocks[0].classList.add('t-product-eyebrow');
      }

      if (textBlocks[1]) {
        textBlocks[1].classList.add('t-product-subtitle');
      }

      const titleBlock =
        productInfo.querySelector('.product__title');

      if (titleBlock) {
        titleBlock.classList.add('t-product-heading');
      }
    }


    /* =========================================
       LOAD SHOPIFY PRODUCT DATA
    ========================================= */

    let productData;

    try {

      const productPath =
        window.location.pathname.replace(/\/$/, '');

      const response =
        await fetch(
          `${productPath}.js`,
          {
            credentials: 'same-origin'
          }
        );

      if (!response.ok) {
        throw new Error(
          `Unable to load product data: ${response.status}`
        );
      }

      productData =
        await response.json();

    } catch (error) {

      console.error(
        'Loose Tea variant data could not be loaded.',
        error
      );

      return;
    }


    if (
      !productData ||
      !Array.isArray(productData.variants) ||
      !productData.variants.length
    ) {
      return;
    }


    /* =========================================
       IDENTIFY SHOPIFY OPTIONS
    ========================================= */

    const optionNames =
      Array.isArray(productData.options)
        ? productData.options
        : [];


    function getOptionName(index) {

      const option =
        optionNames[index];

      return typeof option === 'string'
        ? option
        : option?.name || '';
    }


    const choiceOptionIndex =
      optionNames.findIndex(
        (_, index) =>
          /^options?$/i.test(
            getOptionName(index).trim()
          )
      );


    const flavourOptionIndex =
      optionNames.findIndex(
        (_, index) =>
          index !== choiceOptionIndex
      );


    if (
      choiceOptionIndex === -1 ||
      flavourOptionIndex === -1
    ) {

      console.warn(
        'Could not identify Loose Tea Shopify options.',
        optionNames
      );

      return;
    }


    const flavourOptionName =
      getOptionName(
        flavourOptionIndex
      );


    const choiceOptionName =
      getOptionName(
        choiceOptionIndex
      );


    /* =========================================
       RADIO HELPERS
    ========================================= */

    function getOptionInputs(
      optionName
    ) {

      return [
        ...scope.querySelectorAll(
          'input[type="radio"]'
        )
      ].filter(input => {

        return (
          input.name === optionName ||
          input.name ===
            `options[${optionName}]`
        );
      });
    }


    function getFlavourInputs() {

      return getOptionInputs(
        flavourOptionName
      );
    }


    function getChoiceInputs() {

      return getOptionInputs(
        choiceOptionName
      );
    }


    function getLabel(input) {

      if (!input?.id) {
        return null;
      }

      return scope.querySelector(
        `label[for="${CSS.escape(
          input.id
        )}"]`
      );
    }


    function getSelectedFlavour() {

      const selected =
        getFlavourInputs().find(
          input =>
            input.checked
        );

      return selected
        ? selected.value
        : null;
    }


    /* =========================================
       VARIANT HELPERS
    ========================================= */

    function getVariantOption(
      variant,
      index
    ) {

      return variant.options?.[
        index
      ];
    }


    function getVariantsForFlavour(
      flavour
    ) {

      return productData.variants.filter(
        variant =>
          getVariantOption(
            variant,
            flavourOptionIndex
          ) === flavour
      );
    }


    function getVariant(
      flavour,
      choice
    ) {

      return productData.variants.find(
        variant =>

          getVariantOption(
            variant,
            flavourOptionIndex
          ) === flavour &&

          getVariantOption(
            variant,
            choiceOptionIndex
          ) === choice
      );
    }


    /* =========================================
       OPTION ORDER
    ========================================= */

    const choiceOrder = {

      '1 Tin': 10,

      '2 Tins': 20,

      'Refill Pack': 30,

      'Tin + Refill Bundle': 40,

      'Tin + Teabags Bundle': 50

    };


    function getChoiceOrder(value) {

      return choiceOrder[value] ?? 999;
    }


    function getValidChoices(
      flavour
    ) {

      return getVariantsForFlavour(
        flavour
      )

        .map(
          variant =>
            getVariantOption(
              variant,
              choiceOptionIndex
            )
        )

        .filter(Boolean)

        .filter(
          (
            value,
            index,
            array
          ) =>
            array.indexOf(value) === index
        )

        .sort(
          (a, b) =>
            getChoiceOrder(a) -
            getChoiceOrder(b)
        );
    }


    /* =========================================
       MONEY + SAVE %
    ========================================= */

    function formatMoney(
      cents
    ) {

      const amount =
        Number(cents || 0) / 100;


      const currency =
        window.Shopify
          ?.currency
          ?.active ||
        productData.currency ||
        'GBP';


      try {

        return new Intl.NumberFormat(
          document.documentElement.lang ||
            'en-GB',
          {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        ).format(amount);

      } catch {

        return `£${amount.toFixed(2)}`;
      }
    }


    function getSavingPercentage(
      variant
    ) {

      const price =
        Number(
          variant?.price || 0
        );


      const compareAt =
        Number(
          variant?.compare_at_price || 0
        );


      if (
        !compareAt ||
        compareAt <= price
      ) {
        return null;
      }


      return Math.round(
        (
          (
            compareAt -
            price
          ) /
          compareAt
        ) *
        100
      );
    }


    /* =========================================
       SUBTEXT
    ========================================= */

function getChoiceSubtext(
  flavour,
  choice
) {

  if (
    flavour === 'Original + Peach' &&
    choice === '2 Tins'
  ) {
    return '1 Original + 1 Peach';
  }

  if (
    choice === '1 Tin'
  ) {
    return '150g · 30 servings';
  }

  if (
    choice === 'Refill Pack'
  ) {
    return '300g · 60 servings';
  }

  return '';
}


    /* =========================================
       RENDER OPTION LABEL
    ========================================= */

    function renderChoiceLabel(
      input,
      flavour
    ) {

      const label =
        getLabel(input);

      if (!label) {
        return;
      }


      const variant =
        getVariant(
          flavour,
          input.value
        );


      if (!variant) {
        return;
      }


      const saving =
        getSavingPercentage(
          variant
        );


      const subtext =
        getChoiceSubtext(
          flavour,
          input.value
        );


      label.innerHTML = `

        <span class="t-pack-main">

          <span class="t-pack-name">
            ${input.value}
          </span>

          <span class="t-pack-right">

            ${
              saving
                ? `
                  <span class="t-save-badge">
                    Save ${saving}%
                  </span>
                `
                : ''
            }

            <span class="t-pack-price">
              ${formatMoney(
                variant.price
              )}
            </span>

          </span>

        </span>

        ${
          subtext
            ? `
              <span class="t-pack-subtext">
                ${subtext}
              </span>
            `
            : ''
        }

      `;
    }


    /* =========================================
       FLAVOUR ICONS
    ========================================= */

    function decorateFlavourLabels() {

      const script =
        document.querySelector(
          'script[src*="t-loose-tea-variants.js"]'
        );


      if (!script) {
        return;
      }


      const flavourImages = {

        'Original':
          script.dataset
            .flavourOriginal,

        'Peach':
          script.dataset
            .flavourPeach,

        'Original + Peach':
          script.dataset
            .flavourMixed

      };


      getFlavourInputs().forEach(
        input => {

          const label =
            getLabel(input);


          const image =
            flavourImages[
              input.value
            ];


          if (
            !label ||
            !image
          ) {
            return;
          }


          let icon =
            label.querySelector(
              '.t-flavour-icon'
            );


          if (!icon) {

            icon =
              document.createElement(
                'img'
              );


            icon.className =
              't-flavour-icon';


            icon.alt =
              '';


            icon.setAttribute(
              'aria-hidden',
              'true'
            );


            label.prepend(
              icon
            );
          }


          icon.src =
            image;
        }
      );
    }


    function initialiseFlavourIcons() {

      decorateFlavourLabels();


      let attempts =
        0;


      const iconTimer =
        setInterval(
          () => {

            decorateFlavourLabels();


            attempts += 1;


            if (
              attempts >= 20
            ) {

              clearInterval(
                iconTimer
              );
            }

          },
          100
        );
    }


    /* =========================================
       PREVENT PAGE JUMP
    ========================================= */

    const nativeScrollIntoView =
      Element.prototype.scrollIntoView;


    let restoreGalleryScrollTimer =
      null;


    function containGalleryScroll() {

      if (
        restoreGalleryScrollTimer
      ) {

        clearTimeout(
          restoreGalleryScrollTimer
        );
      }


      Element.prototype.scrollIntoView =
        function (...args) {

          const mediaItem =
            this.matches?.(
              '.product__media-item'
            )
              ? this
              : this.closest?.(
                  '.product__media-item'
                );


          const mediaGallery =
            this.matches?.(
              'media-gallery'
            )
              ? this
              : this.closest?.(
                  'media-gallery'
                );


          if (
            mediaItem ||
            mediaGallery
          ) {

            const item =
              mediaItem ||
              mediaGallery
                ?.querySelector(
                  '.product__media-item.is-active'
                );


            const mediaList =
              item?.closest(
                '.product__media-list'
              );


            if (
              item &&
              mediaList
            ) {

              mediaList.scrollTo({

                left:
                  item.offsetLeft -
                  mediaList.offsetLeft,

                behavior:
                  'auto'

              });
            }


            return;
          }


          return nativeScrollIntoView.apply(
            this,
            args
          );
        };


      restoreGalleryScrollTimer =
        setTimeout(
          () => {

            Element.prototype.scrollIntoView =
              nativeScrollIntoView;


            restoreGalleryScrollTimer =
              null;

          },
          800
        );
    }


    /* =========================================
       DRAWER
    ========================================= */

    function getChoiceGroup() {

      const inputs =
        getChoiceInputs();


      if (!inputs.length) {
        return null;
      }


      return inputs[0].closest(
        '.product-form__input'
      );
    }


    function createChoiceDrawer() {

      const group =
        getChoiceGroup();


      const inputs =
        getChoiceInputs();


      if (
        !group ||
        !inputs.length
      ) {
        return null;
      }


      let drawer =
        group.querySelector(
          '.t-pack-drawer'
        );


      if (drawer) {
        return drawer;
      }


      drawer =
        document.createElement(
          'div'
        );


      drawer.className =
        't-pack-drawer';


      group.insertBefore(
        drawer,
        inputs[0]
      );


      inputs.forEach(
        input => {

          const label =
            getLabel(input);


          drawer.appendChild(
            input
          );


          if (label) {

            drawer.appendChild(
              label
            );
          }

        }
      );


      return drawer;
    }


    function getChoiceDrawer() {

      return (
        getChoiceGroup()
          ?.querySelector(
            '.t-pack-drawer'
          ) ||
        createChoiceDrawer()
      );
    }


    /* =========================================
       MORE / LESS OPTIONS
    ========================================= */

    let choicesExpanded =
      false;


    let choiceAnimating =
      false;


    const PEEK_HEIGHT =
      36;


    function getChoiceToggle() {

      return getChoiceGroup()
        ?.querySelector(
          '.t-more-packs'
        );
    }


    function createChoiceToggle() {

      const group =
        getChoiceGroup();


      const drawer =
        getChoiceDrawer();


      if (
        !group ||
        !drawer
      ) {
        return null;
      }


      let button =
        getChoiceToggle();


      if (button) {
        return button;
      }


      button =
        document.createElement(
          'button'
        );


      button.type =
        'button';


      button.className =
        't-more-packs';


      button.textContent =
        'More options';


      drawer.insertAdjacentElement(
        'afterend',
        button
      );


      button.addEventListener(
        'click',
        () => {

          if (
            choiceAnimating
          ) {
            return;
          }


          if (
            choicesExpanded
          ) {

            closeChoiceDrawer();

          } else {

            openChoiceDrawer();
          }

        }
      );


      return button;
    }


    function updateChoiceToggle(
      validChoices
    ) {

      const button =
        createChoiceToggle();


      if (!button) {
        return;
      }


      button.style.display =
        validChoices.length > 2
          ? ''
          : 'none';


      button.classList.toggle(
        'is-open',
        choicesExpanded
      );


      button.textContent =
        choicesExpanded
          ? 'Less options'
          : 'More options';
    }


    /* =========================================
       COLLAPSED HEIGHT WITH REAL CARD PEEK
    ========================================= */

    function getCollapsedHeight(
      flavour
    ) {

      const drawer =
        getChoiceDrawer();


      if (!drawer) {
        return null;
      }


      const validChoices =
        getValidChoices(
          flavour
        );


      /*
        No hidden options:
        no peek required.
      */

      if (
        validChoices.length <= 2
      ) {

        return drawer.scrollHeight;
      }


      const inputs =
        getChoiceInputs();


      const thirdInput =
        inputs.find(
          input =>
            input.value ===
            validChoices[2]
        );


      const thirdLabel =
        getLabel(
          thirdInput
        );


      if (!thirdLabel) {
        return null;
      }


      const drawerRect =
        drawer.getBoundingClientRect();


      const thirdRect =
        thirdLabel.getBoundingClientRect();


      return (
        thirdRect.top -
        drawerRect.top +
        PEEK_HEIGHT
      );
    }


    function setCollapsedDrawerHeight(
      flavour
    ) {

      const drawer =
        getChoiceDrawer();


      if (!drawer) {
        return;
      }


      const validChoices =
        getValidChoices(
          flavour
        );


      if (
        validChoices.length <= 2
      ) {

        drawer.style.height =
          'auto';


        drawer.style.overflow =
          'hidden';


        return;
      }


      const collapsedHeight =
        getCollapsedHeight(
          flavour
        );


      if (
        collapsedHeight === null
      ) {
        return;
      }


      drawer.style.height =
        `${collapsedHeight}px`;


      drawer.style.overflow =
        'hidden';
    }


    /* =========================================
       APPLY LAYOUT
    ========================================= */

    function applyChoiceLayout(
      flavour
    ) {

      const inputs =
        getChoiceInputs();


      const drawer =
        getChoiceDrawer();


      if (!drawer) {
        return;
      }


      const validChoices =
        getValidChoices(
          flavour
        );


      const orderedInputs =
        [
          ...inputs
        ].sort(
          (a, b) =>
            getChoiceOrder(
              a.value
            ) -
            getChoiceOrder(
              b.value
            )
        );


      /*
        Keep ALL valid real options
        rendered inside the drawer.

        The drawer height itself creates
        the collapsed peek.
      */

      orderedInputs.forEach(
        input => {

          const label =
            getLabel(input);


          if (!label) {
            return;
          }


          const valid =
            validChoices.includes(
              input.value
            );


          input.style.display =
            valid
              ? ''
              : 'none';


          label.style.display =
            valid
              ? ''
              : 'none';


          if (valid) {

            renderChoiceLabel(
              input,
              flavour
            );
          }


          drawer.appendChild(
            input
          );


          drawer.appendChild(
            label
          );

        }
      );


      updateChoiceToggle(
        validChoices
      );


      if (
        choicesExpanded ||
        validChoices.length <= 2
      ) {

        drawer.style.height =
          'auto';


        drawer.style.overflow =
          'hidden';

      } else {

        requestAnimationFrame(
          () => {

            setCollapsedDrawerHeight(
              flavour
            );

          }
        );
      }
    }


    /* =========================================
       OPEN DRAWER
    ========================================= */

    function openChoiceDrawer() {

      const flavour =
        getSelectedFlavour();


      if (!flavour) {
        return;
      }


      const drawer =
        getChoiceDrawer();


      const button =
        getChoiceToggle();


      if (!drawer) {
        return;
      }


      choiceAnimating =
        true;


      const startHeight =
        drawer
          .getBoundingClientRect()
          .height;


      choicesExpanded =
        true;


      drawer.style.height =
        'auto';


      const endHeight =
        drawer.scrollHeight;


      drawer.style.height =
        `${startHeight}px`;


      drawer.style.overflow =
        'hidden';


      drawer.style.transition =
        'height 420ms cubic-bezier(0.22, 1, 0.36, 1)';


      drawer.offsetHeight;


      requestAnimationFrame(
        () => {

          drawer.style.height =
            `${endHeight}px`;

        }
      );


      if (button) {

        button.classList.add(
          'is-open'
        );


        button.textContent =
          'Less options';
      }


      setTimeout(
        () => {

          drawer.style.height =
            'auto';


          drawer.style.overflow =
            'hidden';


          drawer.style.transition =
            '';


          choiceAnimating =
            false;

        },
        430
      );
    }


    /* =========================================
       CLOSE DRAWER
    ========================================= */

    function closeChoiceDrawer() {

      const flavour =
        getSelectedFlavour();


      if (!flavour) {
        return;
      }


      const drawer =
        getChoiceDrawer();


      const button =
        getChoiceToggle();


      if (!drawer) {
        return;
      }


      choiceAnimating =
        true;


      const startHeight =
        drawer
          .getBoundingClientRect()
          .height;


      const endHeight =
        getCollapsedHeight(
          flavour
        );


      if (
        endHeight === null
      ) {

        choiceAnimating =
          false;

        return;
      }


      drawer.style.height =
        `${startHeight}px`;


      drawer.style.overflow =
        'hidden';


      drawer.style.transition =
        'height 420ms cubic-bezier(0.22, 1, 0.36, 1)';


      drawer.offsetHeight;


      requestAnimationFrame(
        () => {

          drawer.style.height =
            `${endHeight}px`;

        }
      );


      if (button) {

        button.classList.remove(
          'is-open'
        );


        button.textContent =
          'More options';
      }


      setTimeout(
        () => {

          choicesExpanded =
            false;


          drawer.style.height =
            `${endHeight}px`;


          drawer.style.overflow =
            'hidden';


          drawer.style.transition =
            '';


          choiceAnimating =
            false;

        },
        430
      );
    }


    /* =========================================
       UPDATE OPTIONS
    ========================================= */

    function updateChoiceOptions(
      options = {}
    ) {

      const {

        resetExpansion =
          false,

        allowSelectedExpansion =
          false,

        forceFirstChoice =
          false

      } = options;


      const flavour =
        getSelectedFlavour();


      if (!flavour) {
        return;
      }


      const validChoices =
        getValidChoices(
          flavour
        );


      const inputs =
        getChoiceInputs();


      if (
        !validChoices.length ||
        !inputs.length
      ) {
        return;
      }


      if (
        resetExpansion
      ) {

        choicesExpanded =
          false;
      }


      let selectedInput =
        inputs.find(
          input =>
            input.checked
        );


      const firstAvailableChoice =
        validChoices.find(
          choice => {

            const variant =
              getVariant(
                flavour,
                choice
              );


            return (
              variant &&
              variant.available !== false
            );
          }
        );


      const firstValidChoice =
        firstAvailableChoice ||
        validChoices[0];


      const firstValidInput =
        inputs.find(
          input =>
            input.value ===
            firstValidChoice
        );


      if (
        forceFirstChoice &&
        firstValidInput &&
        !firstValidInput.checked
      ) {

        containGalleryScroll();


        firstValidInput.click();


        selectedInput =
          firstValidInput;
      }


      if (
        allowSelectedExpansion &&
        selectedInput &&
        validChoices.indexOf(
          selectedInput.value
        ) > 1
      ) {

        choicesExpanded =
          true;
      }


      applyChoiceLayout(
        flavour
      );
    }


    /* =========================================
       FLAVOUR CHANGE
    ========================================= */

    scope.addEventListener(
      'change',
      event => {

        if (
          !(
            event.target instanceof
            HTMLInputElement
          )
        ) {
          return;
        }


        const isFlavour =
          getFlavourInputs().includes(
            event.target
          );


        if (!isFlavour) {
          return;
        }


        containGalleryScroll();


        choicesExpanded =
          false;


        requestAnimationFrame(
          decorateFlavourLabels
        );


        setTimeout(
          () => {

            updateChoiceOptions({

              resetExpansion:
                true,

              forceFirstChoice:
                true

            });

          },
          50
        );


        setTimeout(
          () => {

            updateChoiceOptions({

              resetExpansion:
                true,

              forceFirstChoice:
                true

            });


            decorateFlavourLabels();

          },
          200
        );

      }
    );


    /* =========================================
       RESIZE
    ========================================= */

    window.addEventListener(
      'resize',
      () => {

        const flavour =
          getSelectedFlavour();


        if (
          !flavour ||
          choicesExpanded
        ) {
          return;
        }


        requestAnimationFrame(
          () => {

            setCollapsedDrawerHeight(
              flavour
            );

          }
        );

      }
    );


    /* =========================================
       INITIALISE
    ========================================= */

    createChoiceDrawer();

    createChoiceToggle();

    initialiseFlavourIcons();


    updateChoiceOptions({

      allowSelectedExpansion:
        true

    });

  }


  /* =========================================
     START
  ========================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initLooseTeaVariants
    );

  } else {

    initLooseTeaVariants();
  }

})();